import React from "react";
import * as S from "./styles";
import { useStore } from "./useStore";
import { Title } from "../../Atoms/Title";
import { FormStoreScheduling } from "../../Molecules/FormStoreScheduling";
import { FormStoreRescheduling } from "../../Molecules/FormStoreRescheduling";
import { MyModal } from "../../Atoms/MyModal";
import { Button } from "../../Atoms/Button";
import { reverseToBrDate } from "../../../utils/dateTransform";
import { SwitchOptions } from "../../Atoms/SwitchOptions";
import { TipoAtendimentoEnum } from "../../../enums/tipoAtendimento";
import { FormDeliveryRescheduling } from "../../Molecules/FormDeliveryRescheduling";

const TipoAtendimentoOptions = [
  {
    label: "Loja",
    value: TipoAtendimentoEnum.LOJA,
  },
  {
    label: "Delivery",
    value: TipoAtendimentoEnum.DOMICILIO,
  },
];

export const StoreTemplate = () => {
  const {
    reagendamento,
    submitAgendamento,
    handleReagendamento,
    modal,
    setModal,
    submitReagendamentoForm,
    setTipoAtendimento,
    tipoAtendimento,
    handleRescheduling,
    uuidLoja,
    dataDelivery,
  } = useStore();

  return (
    <S.Container>
      {reagendamento && (
        <S.WrapperSwitch>
          <SwitchOptions
            value={tipoAtendimento}
            // disabled={!!uuidDelivery}
            options={TipoAtendimentoOptions}
            className="optionAtendance"
            handleOnChange={(v) => {
              if (dataDelivery?.delivery?.uuid) return;
              setTipoAtendimento(TipoAtendimentoEnum[v]);
            }}
          />
        </S.WrapperSwitch>
      )}

      <Title className="title">
        {tipoAtendimento === TipoAtendimentoEnum.LOJA ? "Loja" : "Delivery"}
      </Title>

      {!reagendamento ? (
        <FormStoreScheduling onSubmitForm={submitAgendamento} />
      ) : tipoAtendimento === TipoAtendimentoEnum.LOJA ? (
        <FormStoreRescheduling
          uuidLoja={uuidLoja}
          onSubmitForm={submitReagendamentoForm}
        />
      ) : (
        <FormDeliveryRescheduling
          data={dataDelivery}
          submitForm={handleRescheduling}
        />
      )}

      <MyModal
        isOpen={modal.isOpen}
        onRequestClose={() => setModal({ isOpen: false })}
      >
        <S.ModalContent>
          <p>{`Confirma sua vistoria para o dia ${modal?.reagendamento?.diaAgendado} às ${modal?.reagendamento?.horaAgendada}? `}</p>
          <Button onClick={handleReagendamento}>Confirmar</Button>
        </S.ModalContent>
      </MyModal>
      <MyModal
        isOpen={modal.isOpen}
        onRequestClose={() => setModal({ isOpen: false })}
      >
        <S.ModalContent>
          <S.HeaderModal>
            <S.WrapperButtonClose>
              <button onClick={() => setModal({ isOpen: false })}>X</button>
            </S.WrapperButtonClose>
          </S.HeaderModal>
          <S.WrapperText>
            <p>
              <span>{`Confirma`}</span> sua vistoria para o{" "}
              <span>
                dia {reverseToBrDate(modal?.reagendamento?.diaAgendado)} às{" "}
                {modal?.reagendamento?.horaAgendada}?
              </span>
            </p>
            <S.WrapperButtonsModal>
              <button onClick={() => setModal({ isOpen: false })}>
                Cancelar
              </button>
              <Button onClick={handleReagendamento}>Confirmar</Button>
            </S.WrapperButtonsModal>
          </S.WrapperText>
        </S.ModalContent>
      </MyModal>
    </S.Container>
  );
};
